module.exports = __webpack_public_path__ + "img/applicable-scene-4.4f5d4a8.png";